import React from "react";
import TournamentCard from "./TournamentCard.mjs";
import Pagination from "./Pagination.mjs";
import DateBlock
  from "./DateBlock.mjs";
import Tag
  from "./Tag.mjs";

export default function TournamentsList({ data }) {
  return (
    <section aria-labelledby="tournaments-heading" className="vstack gap-3">
      <h3 id="tournaments-heading" className="h2 mb-0 text-primary">
        Live Tournaments
      </h3>

      {data.length > 0 ? <MappedTournamentsList data={data} /> : <NoTournaments /> }
    </section>
  );
}

function MappedTournamentsList({ data }) {
  return(
    <>
      {data.map((tournament) => (
        <TournamentCard key={tournament.id} {...tournament} />
      ))}
      {/*<Pagination />*/}
    </>
  );
}

function NoTournaments() {
  return(
    <div className="bg-white rounded shadow p-4">
      <div className="row">
        <div className="col">
          <p className="mb-0 subhead-2 text-center">No current or upcoming tournaments.</p>
        </div>
      </div>
    </div>
  );
}
